import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./loader.module.scss";

function Loader({className, message}) {
  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.message}>{message}</div>
      <div className={styles.loader} />
    </div>
  );
}

Loader.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string
};

export default Loader;
